import React from 'react';
import { useTheme } from 'styled-components';

export const MoveOutSvg = (props) => {

  const { width, height, color } = props;

  const theme = useTheme();

  return (
    <svg width={width ?? "14"} height={height ?? "14"} viewBox="0 0 14 14" fill={color ?? theme?.colour?.primary ?? "#6457E8"} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.92387 0.333313H10.2834C11.9632 0.333313 13.3331 1.66665 13.3331 3.29331V10.7066C13.3331 12.34 11.9632 13.6666 10.2696 13.6666H6.91699C5.23722 13.6666 3.86036 12.34 3.86036 10.7133V7.51331H8.12862L7.02714 8.57998C6.82061 8.77998 6.82061 9.10665 7.02714 9.30665C7.1304 9.40665 7.26809 9.45331 7.40577 9.45331C7.53657 9.45331 7.67426 9.40665 7.77752 9.30665L9.78774 7.36665C9.891 7.27331 9.94608 7.13998 9.94608 6.99998C9.94608 6.86665 9.891 6.73331 9.78774 6.63998L7.77752 4.69998C7.571 4.49998 7.23367 4.49998 7.02714 4.69998C6.82061 4.89998 6.82061 5.22665 7.02714 5.42665L8.12862 6.48665H3.86036V3.29998C3.86036 1.66665 5.23722 0.333313 6.92387 0.333313ZM0.666504 6.99991C0.666504 6.71991 0.903323 6.48658 1.18751 6.48658H3.86018V7.51325H1.18751C0.903323 7.51325 0.666504 7.28658 0.666504 6.99991Z" />
    </svg>
  );
}